// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HostDetail-pageContent-faQxE {
	max-width: var(--max-content-width);
	position: relative;
	display: block;
	margin: 0px auto;
	padding: 0px;
}

.HostDetail-titleText-QHUbJ {
	font-size: 30px;
	margin: 0px;
	color: var(--primary-foreground);
	font-weight: bold;
	word-break: break-word;
}

.HostDetail-titleText-QHUbJ:hover,
.HostDetail-titleText-QHUbJ:active,
.HostDetail-titleText-QHUbJ:focus {
	color: var(--primary-foreground);
	text-decoration: none;
}

.HostDetail-sectionTitleText-lTRaQ {
	font-size: 20px;
	margin: 0px;
	margin-bottom: 16px;
	font-weight: 600;
}

.HostDetail-sectionTitleContent-SofiB {
	font-size: 16px;
	color: var(--secondary-foreground);
}

.HostDetail-sectionCaptionLink-bi_El {
	font-size: 16px;
	color: var(--secondary-foreground);
}

a {
	cursor: pointer;
}

a:focus {
	outline: none;
}

.HostDetail-textMuted-eB7rQ,
.HostDetail-textMuted-eB7rQ:hover,
.HostDetail-textMuted-eB7rQ:focus,
.HostDetail-textMuted-eB7rQ:hover:focus {
	color: var(--secondary-foreground);
	text-decoration: none;
	font-size: inherit;
}

.HostDetail-text-Ykmhi {
	color: inherit;
	font-size: inherit;
	font-weight: normal;
}

.HostDetail-textLine-cZaVS {
	text-decoration: line-through;
}

.HostDetail-textCenter-mg1Y_ {
	text-align: center;
}

.HostDetail-textError-j1aca {
	color: var(--alert-color);
}

.HostDetail-horizontalLineThrough-TdV7g {
	position: relative;
	display: block;
}

.HostDetail-pageContent-faQxE .HostDetail-horizontalLineThrough-TdV7g:last-child {
	border-bottom: 0px;
}

.HostDetail-space1-VpHN2 {
	margin-bottom: 6px;
}

.HostDetail-space2-g281E {
	margin-bottom: 12px;
}

.HostDetail-space3-NuUQ5 {
	margin-bottom: 18px;
}

.HostDetail-space4-CxIKT {
	margin-bottom: 24px;
}

.HostDetail-space5-LCfZM {
	margin-bottom: 48px;
}

.HostDetail-spaceTop1-UZ4SH {
	margin-top: 6px;
}

.HostDetail-spaceTop2-ybn45 {
	margin-top: 12px;
}

.HostDetail-spaceTop3-fnIBK {
	margin-top: 18px;
}

.HostDetail-spaceTop4-UVtej {
	margin-top: 24px;
}

.HostDetail-spaceTop5-Y_Jw4 {
	margin-top: 48px;
}

.HostDetail-padding1-gnVpA {
	padding-bottom: 6px;
}

.HostDetail-padding2-csMvs {
	padding-bottom: 12px;
}

.HostDetail-padding3-Y_u7X {
	padding-bottom: 18px;
}

.HostDetail-padding4-E1NIt {
	padding-bottom: 24px;
}

.HostDetail-padding5-VEKm3 {
	padding-bottom: 48px;
}

.HostDetail-paddingTop1-eaQlj {
	padding-top: 6px;
}

.HostDetail-paddingTop2-ipXLx {
	padding-top: 12px;
}

.HostDetail-paddingTop3-qEcTt {
	padding-top: 18px;
}

.HostDetail-paddingTop4-ZVldR {
	padding-top: 24px;
}

.HostDetail-paddingTop5-zbaj_ {
	padding-top: 48px;
}

.HostDetail-noMargin-ZEIoz {
	margin: 0px;
}

.HostDetail-noPadding-B9DkU {
	padding: 0px;
}

.HostDetail-noBorder-PxhgJ {
	border: 0px none !important;
}

.HostDetail-btn-mywnM {
	padding: 7px 21px;
	border-color: var(--primary-border);
	background: transparent;
	color: var(--primary-foreground);
	font-weight: bold;
	font-size: 16px;
	outline: none !important;
}

.HostDetail-btnBlock-W0mhC {
	width: 100%;
	position: relative;
	white-space: normal;
	display: block;
}

.HostDetail-btn-mywnM:hover,
.HostDetail-btn-mywnM:focus,
.HostDetail-btn-mywnM:hover:focus {
	background: transparent;
	color: var(--primary-foreground);
}

.HostDetail-formControlSelect-pImIb {
	margin-bottom: 8px;
}

.HostDetail-splitList-fEK5L {
	display: inline-block;
	width: 50%;
	font-size: 16px;
	padding-right: 8px;
}

.HostDetail-displayTable-ASvqQ {
	display: table;
	width: 100%;
}

.HostDetail-displayTableRow-Dm9uP {
	display: table-row;
	width: 100%;
}

.HostDetail-displayTableCell-klYJ3 {
	display: table-cell;
	width: 100%;
}

.HostDetail-displayTableCellIcon-ACkzK {
	display: table-cell;
	vertical-align: top;
}

.HostDetail-textMutedNew-dokTF {
	font-size: 16px;
	font-weight: 700;
	vertical-align: middle;
	word-break: break-word;
	line-height: 26px;
}

.HostDetail-tableMarginTop-xOtWZ {
	margin-top: 16px;
}

.HostDetail-calendarTableCell-feDwf {
	display: inline-block;
}

.HostDetail-vrAlignTop-t0f8I {
	vertical-align: top;
}

.HostDetail-currenyMarginR-DT7NG {
	margin-right: 6px;
}

.HostDetail-sectionLink-Fm9xS {
	border: 1px solid var(--secondary-bg);
	padding: 10px;
	border-radius: 4px;
}

.HostDetail-listingFontSize-vgAuU {
	font-size: 16px !important;
}

.HostDetail-vrAlignBottom-B5GhF {
	vertical-align: bottom;
}

.HostDetail-introTextPadding-QayAx {
	padding-left: 8px;
}

.HostDetail-showHideBtn-MkKe2 {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: 16px !important;
	border: 0px !important;
	text-decoration: underline;
}

.HostDetail-showHideBtn-MkKe2.HostDetail-focus-Ypu3d,
.HostDetail-showHideBtn-MkKe2:focus,
.HostDetail-showHideBtn-MkKe2:active,
.HostDetail-showHideBtn-MkKe2:active:focus,
.HostDetail-showHideBtn-MkKe2:focus,
.HostDetail-showHideBtn-MkKe2:hover {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent !important;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: 16px;
	border: 0px !important;
}

.HostDetail-showHideMargin-jgHxJ {
	margin-bottom: 10px !important;
}

.HostDetail-listingIntroWidth-DQkbj {
	width: 65%;
}

.HostDetail-showHidePadding-RmKWb {
	padding-bottom: 10px !important;
}

.HostDetail-vtrTop-ucWaB {
	vertical-align: top;
}

.HostDetail-listingLine-coX7U {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.HostDetail-listingLineTwo-e6EZO {
	margin: 15px 0 30px;
}

@media screen and (max-width: 767px) {
	.HostDetail-titleText-QHUbJ {
		font-weight: 700;
		font-size: 26px;
		word-break: break-word;
	}

	.HostDetail-splitList-fEK5L {
		display: inline-block;
		width: 100% !important;
	}

	.HostDetail-listingIntroWidth-DQkbj {
		width: 100% !important;
	}

	.HostDetail-responsiveListIngIntro-EWitM {
		display: inline-block !important;
	}
}

.HostDetail-profileAvatarLink-xIdFC {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	overflow: hidden;
	border-radius: 50%;
	background-color: var(--secondary-gray-bg);
	border: 2px solid var(--primary-border);
}

.HostDetail-profileAvatar-iKEiA {
	height: 90px;
	width: 90px;
}

.HostDetail-flex-b3459 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-column-gap: 15px;
	   -moz-column-gap: 15px;
	        column-gap: 15px;
}

.HostDetail-titleText-QHUbJ {
	font-size: 20px;
	margin-bottom: 10px;
}

.HostDetail-infoContent-ku0E7 {
	margin: 15px 0 25px;
	font-size: 16px;
}

.HostDetail-btnPrimary-f8aS1 {
	border-color: var(--primary-bg) !important;
	background-color: var(--primary-bg) !important;
	color: var(--primary-btn-foreground) !important;
	padding: 7px 21px;
	font-weight: 500;
	font-size: 16px;
	border-radius: 4px;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	text-decoration: none !important;
	cursor: pointer;
}

.HostDetail-btnPrimary-f8aS1:hover,
.HostDetail-btnPrimary-f8aS1:focus,
.HostDetail-btnPrimary-f8aS1:active,
.HostDetail-btnPrimary-f8aS1:active:hover,
.HostDetail-btnPrimary-f8aS1:active:focus {
	border-color: var(--primary-bg) !important;
	background-color: var(--primary-bg) !important;
	color: var(--primary-btn-foreground);
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
}

@media screen and (max-width: 767px) {
	.HostDetail-profileAvatar-iKEiA {
		height: 54px;
		width: 54px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/common.css","webpack://./src/components/ViewListing/HostDetail/HostDetail.css"],"names":[],"mappings":"AAAA;CACC,mCAAmC;CACnC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,WAAW;CACX,gCAAgC;CAChC,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;;;CAGC,gCAAgC;CAChC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;;;;CAIC,kCAAkC;CAClC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;CACjB,mCAAmC;CACnC,uBAAuB;CACvB,gCAAgC;CAChC,iBAAiB;CACjB,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;AACf;;AAEA;;;CAGC,uBAAuB;CACvB,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qCAAqC;CACrC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,uBAAuB;CACvB,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,0BAA0B;CAC1B,sBAAsB;CACtB,0BAA0B;AAC3B;;AAEA;;;;;;CAMC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kCAAkC;CAClC,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC;EACC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;CACvB;;CAEA;EACC,qBAAqB;EACrB,sBAAsB;CACvB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gCAAgC;CACjC;AACD;;ACjWA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB,0CAA0C;CAC1C,uCAAuC;AACxC;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,0CAA0C;CAC1C,8CAA8C;CAC9C,+CAA+C;CAC/C,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,mCAA2B;SAA3B,2BAA2B;CAC3B,gCAAgC;CAChC,eAAe;AAChB;;AAEA;;;;;CAKC,0CAA0C;CAC1C,8CAA8C;CAC9C,oCAAoC;CACpC,mCAA2B;SAA3B,2BAA2B;AAC5B;;AAEA;CACC;EACC,YAAY;EACZ,WAAW;CACZ;AACD","sourcesContent":[".pageContent {\n\tmax-width: var(--max-content-width);\n\tposition: relative;\n\tdisplay: block;\n\tmargin: 0px auto;\n\tpadding: 0px;\n}\n\n.titleText {\n\tfont-size: 30px;\n\tmargin: 0px;\n\tcolor: var(--primary-foreground);\n\tfont-weight: bold;\n\tword-break: break-word;\n}\n\n.titleText:hover,\n.titleText:active,\n.titleText:focus {\n\tcolor: var(--primary-foreground);\n\ttext-decoration: none;\n}\n\n.sectionTitleText {\n\tfont-size: 20px;\n\tmargin: 0px;\n\tmargin-bottom: 16px;\n\tfont-weight: 600;\n}\n\n.sectionTitleContent {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\n.sectionCaptionLink {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\na {\n\tcursor: pointer;\n}\n\na:focus {\n\toutline: none;\n}\n\n.textMuted,\n.textMuted:hover,\n.textMuted:focus,\n.textMuted:hover:focus {\n\tcolor: var(--secondary-foreground);\n\ttext-decoration: none;\n\tfont-size: inherit;\n}\n\n.text {\n\tcolor: inherit;\n\tfont-size: inherit;\n\tfont-weight: normal;\n}\n\n.textLine {\n\ttext-decoration: line-through;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.textError {\n\tcolor: var(--alert-color);\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tdisplay: block;\n}\n\n.pageContent .horizontalLineThrough:last-child {\n\tborder-bottom: 0px;\n}\n\n.space1 {\n\tmargin-bottom: 6px;\n}\n\n.space2 {\n\tmargin-bottom: 12px;\n}\n\n.space3 {\n\tmargin-bottom: 18px;\n}\n\n.space4 {\n\tmargin-bottom: 24px;\n}\n\n.space5 {\n\tmargin-bottom: 48px;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px;\n}\n\n.spaceTop5 {\n\tmargin-top: 48px;\n}\n\n.padding1 {\n\tpadding-bottom: 6px;\n}\n\n.padding2 {\n\tpadding-bottom: 12px;\n}\n\n.padding3 {\n\tpadding-bottom: 18px;\n}\n\n.padding4 {\n\tpadding-bottom: 24px;\n}\n\n.padding5 {\n\tpadding-bottom: 48px;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px;\n}\n\n.paddingTop5 {\n\tpadding-top: 48px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.noBorder {\n\tborder: 0px none !important;\n}\n\n.btn {\n\tpadding: 7px 21px;\n\tborder-color: var(--primary-border);\n\tbackground: transparent;\n\tcolor: var(--primary-foreground);\n\tfont-weight: bold;\n\tfont-size: 16px;\n\toutline: none !important;\n}\n\n.btnBlock {\n\twidth: 100%;\n\tposition: relative;\n\twhite-space: normal;\n\tdisplay: block;\n}\n\n.btn:hover,\n.btn:focus,\n.btn:hover:focus {\n\tbackground: transparent;\n\tcolor: var(--primary-foreground);\n}\n\n.formControlSelect {\n\tmargin-bottom: 8px;\n}\n\n.splitList {\n\tdisplay: inline-block;\n\twidth: 50%;\n\tfont-size: 16px;\n\tpadding-right: 8px;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\twidth: 100%;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\twidth: 100%;\n}\n\n.displayTableCellIcon {\n\tdisplay: table-cell;\n\tvertical-align: top;\n}\n\n.textMutedNew {\n\tfont-size: 16px;\n\tfont-weight: 700;\n\tvertical-align: middle;\n\tword-break: break-word;\n\tline-height: 26px;\n}\n\n.tableMarginTop {\n\tmargin-top: 16px;\n}\n\n.calendarTableCell {\n\tdisplay: inline-block;\n}\n\n.vrAlignTop {\n\tvertical-align: top;\n}\n\n.currenyMarginR {\n\tmargin-right: 6px;\n}\n\n.sectionLink {\n\tborder: 1px solid var(--secondary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n}\n\n.listingFontSize {\n\tfont-size: 16px !important;\n}\n\n.vrAlignBottom {\n\tvertical-align: bottom;\n}\n\n.introTextPadding {\n\tpadding-left: 8px;\n}\n\n.showHideBtn {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: 16px !important;\n\tborder: 0px !important;\n\ttext-decoration: underline;\n}\n\n.showHideBtn.focus,\n.showHideBtn:focus,\n.showHideBtn:active,\n.showHideBtn:active:focus,\n.showHideBtn:focus,\n.showHideBtn:hover {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent !important;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: 16px;\n\tborder: 0px !important;\n}\n\n.showHideMargin {\n\tmargin-bottom: 10px !important;\n}\n\n.listingIntroWidth {\n\twidth: 65%;\n}\n\n.showHidePadding {\n\tpadding-bottom: 10px !important;\n}\n\n.vtrTop {\n\tvertical-align: top;\n}\n\n.listingLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.listingLineTwo {\n\tmargin: 15px 0 30px;\n}\n\n@media screen and (max-width: 767px) {\n\t.titleText {\n\t\tfont-weight: 700;\n\t\tfont-size: 26px;\n\t\tword-break: break-word;\n\t}\n\n\t.splitList {\n\t\tdisplay: inline-block;\n\t\twidth: 100% !important;\n\t}\n\n\t.listingIntroWidth {\n\t\twidth: 100% !important;\n\t}\n\n\t.responsiveListIngIntro {\n\t\tdisplay: inline-block !important;\n\t}\n}","@import '../common.css';\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 2px solid var(--primary-border);\n}\n\n.profileAvatar {\n\theight: 90px;\n\twidth: 90px;\n}\n\n.flex {\n\tdisplay: flex;\n\talign-items: center;\n\tcolumn-gap: 15px;\n}\n\n.titleText {\n\tfont-size: 20px;\n\tmargin-bottom: 10px;\n}\n\n.infoContent {\n\tmargin: 15px 0 25px;\n\tfont-size: 16px;\n}\n\n.btnPrimary {\n\tborder-color: var(--primary-bg) !important;\n\tbackground-color: var(--primary-bg) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n\tpadding: 7px 21px;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tborder-radius: 4px;\n\tbox-shadow: none !important;\n\ttext-decoration: none !important;\n\tcursor: pointer;\n}\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus {\n\tborder-color: var(--primary-bg) !important;\n\tbackground-color: var(--primary-bg) !important;\n\tcolor: var(--primary-btn-foreground);\n\tbox-shadow: none !important;\n}\n\n@media screen and (max-width: 767px) {\n\t.profileAvatar {\n\t\theight: 54px;\n\t\twidth: 54px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContent": `HostDetail-pageContent-faQxE`,
	"titleText": `HostDetail-titleText-QHUbJ`,
	"sectionTitleText": `HostDetail-sectionTitleText-lTRaQ`,
	"sectionTitleContent": `HostDetail-sectionTitleContent-SofiB`,
	"sectionCaptionLink": `HostDetail-sectionCaptionLink-bi_El`,
	"textMuted": `HostDetail-textMuted-eB7rQ`,
	"text": `HostDetail-text-Ykmhi`,
	"textLine": `HostDetail-textLine-cZaVS`,
	"textCenter": `HostDetail-textCenter-mg1Y_`,
	"textError": `HostDetail-textError-j1aca`,
	"horizontalLineThrough": `HostDetail-horizontalLineThrough-TdV7g`,
	"space1": `HostDetail-space1-VpHN2`,
	"space2": `HostDetail-space2-g281E`,
	"space3": `HostDetail-space3-NuUQ5`,
	"space4": `HostDetail-space4-CxIKT`,
	"space5": `HostDetail-space5-LCfZM`,
	"spaceTop1": `HostDetail-spaceTop1-UZ4SH`,
	"spaceTop2": `HostDetail-spaceTop2-ybn45`,
	"spaceTop3": `HostDetail-spaceTop3-fnIBK`,
	"spaceTop4": `HostDetail-spaceTop4-UVtej`,
	"spaceTop5": `HostDetail-spaceTop5-Y_Jw4`,
	"padding1": `HostDetail-padding1-gnVpA`,
	"padding2": `HostDetail-padding2-csMvs`,
	"padding3": `HostDetail-padding3-Y_u7X`,
	"padding4": `HostDetail-padding4-E1NIt`,
	"padding5": `HostDetail-padding5-VEKm3`,
	"paddingTop1": `HostDetail-paddingTop1-eaQlj`,
	"paddingTop2": `HostDetail-paddingTop2-ipXLx`,
	"paddingTop3": `HostDetail-paddingTop3-qEcTt`,
	"paddingTop4": `HostDetail-paddingTop4-ZVldR`,
	"paddingTop5": `HostDetail-paddingTop5-zbaj_`,
	"noMargin": `HostDetail-noMargin-ZEIoz`,
	"noPadding": `HostDetail-noPadding-B9DkU`,
	"noBorder": `HostDetail-noBorder-PxhgJ`,
	"btn": `HostDetail-btn-mywnM`,
	"btnBlock": `HostDetail-btnBlock-W0mhC`,
	"formControlSelect": `HostDetail-formControlSelect-pImIb`,
	"splitList": `HostDetail-splitList-fEK5L`,
	"displayTable": `HostDetail-displayTable-ASvqQ`,
	"displayTableRow": `HostDetail-displayTableRow-Dm9uP`,
	"displayTableCell": `HostDetail-displayTableCell-klYJ3`,
	"displayTableCellIcon": `HostDetail-displayTableCellIcon-ACkzK`,
	"textMutedNew": `HostDetail-textMutedNew-dokTF`,
	"tableMarginTop": `HostDetail-tableMarginTop-xOtWZ`,
	"calendarTableCell": `HostDetail-calendarTableCell-feDwf`,
	"vrAlignTop": `HostDetail-vrAlignTop-t0f8I`,
	"currenyMarginR": `HostDetail-currenyMarginR-DT7NG`,
	"sectionLink": `HostDetail-sectionLink-Fm9xS`,
	"listingFontSize": `HostDetail-listingFontSize-vgAuU`,
	"vrAlignBottom": `HostDetail-vrAlignBottom-B5GhF`,
	"introTextPadding": `HostDetail-introTextPadding-QayAx`,
	"showHideBtn": `HostDetail-showHideBtn-MkKe2`,
	"focus": `HostDetail-focus-Ypu3d`,
	"showHideMargin": `HostDetail-showHideMargin-jgHxJ`,
	"listingIntroWidth": `HostDetail-listingIntroWidth-DQkbj`,
	"showHidePadding": `HostDetail-showHidePadding-RmKWb`,
	"vtrTop": `HostDetail-vtrTop-ucWaB`,
	"listingLine": `HostDetail-listingLine-coX7U`,
	"listingLineTwo": `HostDetail-listingLineTwo-e6EZO`,
	"responsiveListIngIntro": `HostDetail-responsiveListIngIntro-EWitM`,
	"profileAvatarLink": `HostDetail-profileAvatarLink-xIdFC`,
	"profileAvatar": `HostDetail-profileAvatar-iKEiA`,
	"flex": `HostDetail-flex-b3459`,
	"infoContent": `HostDetail-infoContent-ku0E7`,
	"btnPrimary": `HostDetail-btnPrimary-f8aS1`
};
module.exports = ___CSS_LOADER_EXPORT___;
